import { TabPanel, TabContext, TabList } from "@mui/lab";
import {
  Grid,
  Box,
  Divider,
  ListItemText,
  ListItem,
  ListItemAvatar,
  Dialog,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  List,
  ListItemButton,
  ListItemIcon,
} from "@mui/material";
import { useEffect, useState } from "react";
import "react-multi-carousel/lib/styles.css";
import { loginState, configState } from "../lib/State";
import axios from "axios";
import { ReactComponent as CenterIcon } from '../assets/center.svg'
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CenterInfo from "./CenterInfo";
import get_cid from '../lib/get_cid';
import get_center from '../lib/get_center';

const inputTheme = createTheme({
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          top: '-7px',
          fontSize: '14px'
        },
        shrink: {
          // top: '0px'
          display: 'none'
        },
        nativeInput: {
          fontSize: '14px'
        }
      }
    }
  }
})

function Center(props) {
  const { login } = props;
  const cid= get_cid();
  const center=get_center(cid);
  const [data, setData] = useState([]);
  const [openCenter, setOpenCenter] = useState(false);
  // const [center, setCenter] = useState('');

  const clickOpenCenter = () => {
    setOpenCenter(true);
  };
  const clickCloseCenter = () => {
    setOpenCenter(false);
  };

  // const load_amount = async () => {
  //   let result = await axios.post(configState.api + "/gympass/get_product", { cid: configState.cid });
  //   setData(result.data.rows);
  //   // console.log(result.data.rows);
  // };

  // useEffect(() => {
  //   load_amount();
  // }, []);

  // 카카오지도
  // const mymap = () => {
  //   var container = document.getElementById('map');
  //   var options = { 
  //     center: new kakao.maps.LatLng(35.326227555845335, 129.17126266781744),
  //     level: 3
  //   };

  //   var map = new kakao.maps.Map(container, options);
  //   var markerPosition  = new kakao.maps.LatLng(35.326227555845335, 129.17126266781744);
  //   var marker = new kakao.maps.Marker({
  //     position: markerPosition,	
  //   });
  //   marker.setMap(map);
  // }



  return (
    <Box>
      <Dialog fullScreen open={openCenter} onClose={clickCloseCenter}>
        <Box
          sx={{
            width: "90%",
            textAlign: "left",
            padding: "30px 0 10px 10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <img
            src="/img/back_button_black.png"
            onClick={clickCloseCenter}
          />
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "space-between",
              width: '100%'
            }}>
            <Box
              sx={{
                margin: "25px 0 0 10px",
                fontSize: "22px",
              }}
            >
              센터소개
            </Box>
          </Box>
        </Box>
        <Divider />

        <Grid
          container
          justifyContent="spacearound"
          direction="row"
          width="100%"
          sx={{ zIndex: 1 }}
        >
            <>
              {/* {cid === 'CID00000009' && (
                <CenterJeongguan />
              )}
              {cid === 'CT17X10111035.huwy5' && (
                <CenterGohyeon />
              )}
              {cid === 'CT14Z01170314.HXZb9' && (
                <CenterOkpo />
              )}
              {cid === 'CID00000017' && (
                <CenterOkpo />
              )}
              {cid === 'CT14S15143839.Pdfg3' && (
                <CenterTest login={login} />
              )} */}
              <CenterInfo openCenter={openCenter} />
            </>
        </Grid>
      </Dialog>
      <ListItem
        sx={{ textAlign: "center" }}
        onClick={clickOpenCenter}
      >
        <ListItemAvatar>
          <CenterIcon width='24px' />
        </ListItemAvatar>
        <ListItemText sx={{ textAlign: "left" }}>
          센터소개
        </ListItemText>
        <ListItemAvatar>
          <ArrowRightIcon />
        </ListItemAvatar>
      </ListItem>
    </Box>
  );
}
export default Center;